import {Cookie} from "../utility/cookie";

export const translation = () => {
    const langs = ['en', 'es'];

    const hide = (lang) => {
        document.querySelector(`a[data-lang="${lang}"]`).classList.remove('selected');
        document.querySelectorAll(`.lang.${lang}`).forEach(function (item) {
            item.classList.remove('show')
        });
    }

    const show = (lang) => {
        hide(langs[+(lang === langs[0])]);
        Cookie.set('_kbs_lang', lang);
        document.querySelector(`a[data-lang="${lang}"]`).classList.add('selected');
        document.querySelectorAll(`.lang.${lang}`).forEach(function (item) {
            item.classList.add('show')
        });
    }

    window.addEventListener('load', function () {
        const toggle = document.querySelector('a[data-lang]');
        if (!toggle) {
            return;
        }

        window.location.search.substring(1).split('&').forEach(function (kvp) {
            let key, value;
            [key, value] = kvp.split('=');
            let el = document.getElementById(key);
            if (el && value) {
                el.value = decodeURIComponent(value.replace(/\+/g, ' '));
            }
        });

        show(Cookie.get('_kbs_lang') || 'en');

        document.querySelectorAll('#lang-toggle a').forEach(function (item) {
            item.addEventListener('click', function (e) {
                e.preventDefault();
                let lang = item.getAttribute('data-lang')
                show(lang);
            });
        });
    });
};
